import React, { useEffect, useMemo, useState } from 'react';
import { Alert, Button, Form } from 'react-bootstrap';
import { trackPromise } from 'react-promise-tracker';
import Swal from 'sweetalert2';
import caAPI from '../../../../services/caAPI';
import { successToast } from '../../../../components/DommusToast';
import DommusToggle from '../../../../components/DommusToggle';
import { extrairDados, obterMensagemErro } from '../../GestaoAgentesIa/utils';

function ConfiguracaoOpenAi({ configuracao, setConfiguracao }) {
  const [chaveVectorStore, setChaveVectorStore] = useState('');
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    trackPromise(
      caAPI.configuracaoOpenAi.buscar()
        .then(resposta => setConfiguracao(extrairDados(resposta)))
        .catch(erro => Swal.fire({
          titleText: 'Erro',
          text: obterMensagemErro(erro, 'Erro ao carregar configuração OpenAI.'),
          icon: 'error',
        }))
    );
  }, []);

  const elementoConfiguracao = useMemo(() => {
    function handleSalvar(evento) {
      evento.preventDefault();
      const novaChave = chaveVectorStore.trim();
      if (!novaChave) return;

      setSalvando(true);
      trackPromise(
        caAPI.configuracaoOpenAi.atualizar({ chave_vector_store: novaChave })
          .then(resposta => {
            setConfiguracao(extrairDados(resposta));
            setChaveVectorStore('');
            successToast.fire({ text: 'Chave de Vector Store atualizada com sucesso.' });
          })
          .catch(erro => Swal.fire({
            titleText: 'Erro',
            text: obterMensagemErro(erro, 'Erro ao atualizar configuração OpenAI.'),
            icon: 'error',
          }))
          .finally(() => setSalvando(false))
      );
    }

    return (
      <DommusToggle title="Configuração para Integração com OpenAI" headerClass="mt-3">
        <Alert variant="info">
          O Project é somente leitura. A chave de Vector Store nunca é exibida ou armazenada no navegador.
        </Alert>
        <p className="mb-1"><strong>Project:</strong> {configuracao?.id_projeto_openai || 'Não configurado'}</p>
        <p><strong>Chave de Vector Store:</strong> {configuracao?.chave_vector_store_configurada ? 'Configurada' : 'Não configurada'}</p>
        <Form onSubmit={handleSalvar}>
          <Form.Group controlId="chave-vector-store">
            <Form.Label>Nova chave de Vector Store</Form.Label>
            <Form.Control
              type="password"
              autoComplete="new-password"
              value={chaveVectorStore}
              onChange={evento => setChaveVectorStore(evento.target.value)}
              placeholder="Informe uma nova chave para substituir a atual"
            />
          </Form.Group>
          <Button type="submit" variant="primary" disabled={salvando || !chaveVectorStore.trim()}>
            {salvando ? 'Salvando...' : 'Atualizar chave'}
          </Button>
        </Form>
      </DommusToggle>
    );
  }, [configuracao, chaveVectorStore, salvando]);

  return elementoConfiguracao;
}

export default ConfiguracaoOpenAi;